export const DOC_TYPES = [
  { key: "passport", label: "الجواز" },
  { key: "iqama", label: "الإقامة" },
  { key: "tashark", label: "تشارك" },
  { key: "contract", label: "العقد" },
  { key: "medical_insurance", label: "التأمين الطبي" },
  { key: "delivery_authorization", label: "التفويض للدباب" },
  { key: "health_card", label: "الكارت الصحي" },
  { key: "vehicle_registration", label: "استمارة كرت التشغيل" },
  { key: "rider_vehicle_registration", label: "استمارة مركبة المندوب الأساسية" },
  { key: "operation_card", label: "كرت التشغيل" },
  { key: "driver_card", label: "كرت السائق" },
  { key: "driving_license", label: "رخصة القيادة" },
];

export const DOC_LABELS = DOC_TYPES.reduce((a, d) => ({ ...a, [d.key]: d.label }), {});

export const TASHARK_STATUSES = ["نشط", "موقوف", "منتهي", "قيد المعالجة", "غير مسجل"];

export const EMPLOYEE_STATUSES = ["نشط", "خروج وعودة", "موقوف", "إجازة", "بدون مركبة", "منتهي الخدمة"];

export const SUPPORT_WHATSAPP = "966537069686";
export const PLAN_PRICE = 800;
export const TRIAL_DAYS = 14;

export const STATUS_LABELS = {
  valid: "سارية",
  expiring_soon: "تقترب من الانتهاء",
  expired: "منتهية",
  none: "غير مُدخلة",
};

export const STATUS_STYLES = {
  valid: "bg-blue-50 text-blue-700 border-blue-200",
  expiring_soon: "bg-amber-50 text-amber-700 border-amber-200",
  expired: "bg-red-50 text-red-700 border-red-200",
  none: "bg-slate-50 text-slate-500 border-slate-200",
};

export const ENDED_STATUSES = ["منتهي الخدمة", "خروج نهائي"];
// Org-defined statuses ({name, kind: active|suspended|ended}), loaded once by the dashboard.
let CUSTOM_STATUSES = [];
export const setCustomStatuses = (list) => { CUSTOM_STATUSES = Array.isArray(list) ? list : []; };
export const getCustomStatuses = () => CUSTOM_STATUSES;
export const allEmployeeStatuses = () => [...EMPLOYEE_STATUSES, ...CUSTOM_STATUSES.map((c) => c.name)];
export const isActiveEmp = (e) => {
  const st = e?.employee_status || "";
  return !ENDED_STATUSES.includes(st) && !CUSTOM_STATUSES.some((c) => c.kind === "ended" && c.name === st);
};
